import { render } from "./Home.vue?vue&type=template&id=16538165"
const script = {}
script.render = render

export default script